import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EditEnvironmentViewModel, EnvironmentService, EnvironmentViewModel} from './environments.service';
import {ToastButtons, ToastMessageType, ToastService} from "../Common/toast";
import { MatCard, MatCardTitle, MatCardContent, MatCardSubtitle } from '@angular/material/card';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'my-package',
    templateUrl: "./editEnvironment.html",
    styleUrls: ["../provisioning.css", "./editEnvironment.css"],
    imports: [MatCard, MatCardTitle, MatCardContent, MatSelect, FormsModule, MatOption, MatCheckbox, MatButton, MatCardSubtitle, MatFormField, MatLabel, MatInput, MatIcon]
})
export class EditEnvironmentComponent implements OnInit {
    environment: EnvironmentViewModel;
    viewModel: EditEnvironmentViewModel;
    newKey: string;
    newValue: string;
    newItem: string;
    id: number;
    constructor(
        private service: EnvironmentService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private toast: ToastService
    ) { }

    ngOnInit(): void {
        this.getEnvironments();
        this.id = this.activatedRoute.snapshot.params["id"];
    }
    getProperty(key: string, setting: any) {
        return setting[key];
    }
    setProperty($event: Event, key: string, setting: any) {
        setting[key] = $event.target.valueOf();
    }
    generateArray(obj: any) {
        return Object.keys(obj).filter(k => !k.startsWith("$"));
    }
    getSettingValue(setting: any, settingId: any) {
        return this.viewModel
            .Environment
            .SettingsProviders
            .find((s: any) => s.Id === settingId)[setting.PropertyName];
    }
    newArrayItem(setting: any, key: string) {
        setting.push(key);
        this.newItem = "";
    }
    newValuePair(setting: any, key: string, value: string) {
        setting[key] = value.toString();
        this.newKey = "";
        this.newValue = "";
    }

    save() {
       this.viewModel
            .Environment
            .SettingProviders
            =
            this.viewModel
                .EditModels
            .map(vm => {
                return {
                    $type: vm.JsonType, 
                    ...vm.Provider
                }
            });
        this.service
            .saveConfig(this.viewModel.Environment, this.environment.Id, this.viewModel.CanSeeApis)
            .subscribe(
            r => {
                this.getEnvironments();
                this.toast.sendMessage(
                    "Saved", 
                    "Config has been saved", 
                    ToastMessageType.success, 
                    ToastButtons.None);
            }, error1 => {
                this.toast.sendMessage("Error", error1, ToastMessageType.error, ToastButtons.None)
                });
    }
    getEnvironments() {
        let self = this;
        this.service
            .getEnvironments()
            .subscribe(
            envs => {
                const id = self.id;
                const env = envs.find(e => e.Id == id);
                if (!env) self.router.navigate(["/environments"]);
                this.environment = env;
                this.getConfig(id);
            });
    }

    getConfig(id: number) {
        this.service
            .getConfig(id)
            .subscribe(
            vm => {
                this.viewModel = vm;
                this.viewModel
                    .EditModels
                    .forEach(v => {
                        v.Provider = vm.Environment.SettingProviders.
                            find((s: any) => s.Id === v.Id);
                    });
            }
            );
    }
}